



























































































import ApiConfiguration from '@/classes/ApiConfiguration';
import Vue from 'vue';
import { ExceptionalJobModel, ExceptionalJobStatus } from '@/services/GeneratedApi';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreSimpleTable from '@/components/shared/Table/MStoreSimpleTable.vue';
import { EnumUtils, MStoreTableUtils } from '@/utils';
import { MStoreFormDatePicker } from '@/components/shared';
import MStoreColumnSort from '@/components/shared/Table/MStoreColumnSort.vue';
import { TableSortModel } from '@/types';

export default Vue.extend({
  name: 'ExceptionalJobs',
  data() {
    return {
      isLoading: true,
      isRefreshing: false,
      exceptionalJobs: [] as ExceptionalJobModel[],
      expandedRows: new Set<number>(),
      documentIdFilter: '',
      userFilter: null,
      statusFilter: null,
      createdSinceFilter: null,
      createdBeforeFilter: null,
      sortOptions: [] as TableSortModel[],
      appliedSortOptions: [] as TableSortModel[],
      ExceptionalJobStatus
    };
  },
  computed: {
    availableUsers(this: any) {
      return new Set((this.exceptionalJobs as ExceptionalJobModel[]).map((x) => x.createdByUserName).filter((x) => x));
    },
    filteredItems(this: any) {
      let items: ExceptionalJobModel[] = [...this.exceptionalJobs];

      items = items.filter((x) => {
        if (this.documentIdFilter && !x.targetDocumentId?.toString().includes(this.documentIdFilter)) {
          return false;
        }

        if (this.userFilter && x.createdByUserName !== this.userFilter) {
          return false;
        }

        if (this.statusFilter && x.status !== this.statusFilter) {
          return false;
        }

        const createdDate = new Date(x.createdDate!);
        if (this.createdSinceFilter && createdDate < new Date(this.createdSinceFilter)) {
          return false;
        }

        if (this.createdBeforeFilter && createdDate > new Date(this.createdBeforeFilter)) {
          return false;
        }

        return true;
      });

      return items;
    },
    sortedFilteredItems(this: any) {
      const filteredItems: ExceptionalJobModel[] = [...this.filteredItems];
      return this.appliedSortOptions.length ? MStoreTableUtils.applyDefaultSorting(filteredItems, this.appliedSortOptions) : filteredItems;
    }
  },
  methods: {
    async refreshExceptionalJobs(this: any) {
      this.isRefreshing = true;
      try {
        this.exceptionalJobs = await ApiConfiguration.api().tools.toolsExceptionalJobsList();
        await Vue.nextTick();
        if (this.userFilter && !this.availableUsers.has(this.userFilter)) {
          this.userFilter = null;
        }
      } finally {
        this.isRefreshing = false;
      }
    },
    getStatusString(enumValue: ExceptionalJobStatus) {
      return ExceptionalJobStatus[enumValue];
    },
    toggleRowExpand(this: any, exceptionalJobId: number) {
      const expandedRows: Set<number> = new Set(this.expandedRows as Set<number>);
      if (expandedRows.has(exceptionalJobId)) {
        expandedRows.delete(exceptionalJobId);
      } else {
        expandedRows.add(exceptionalJobId);
      }
      this.expandedRows = expandedRows;
    },
    resetSort(this: any) {
      this.sortOptions = [];
      this.appliedSortOptions = [];
    },
    clearFilters() {
      this.documentIdFilter = '';
      this.userFilter = null;
      this.statusFilter = null;
      this.createdSinceFilter = null;
      this.createdBeforeFilter = null;
    }
  },
  async mounted() {
    try {
      this.exceptionalJobs = await ApiConfiguration.api().tools.toolsExceptionalJobsList();
    } finally {
      this.isLoading = false;
    }
  },
  created(this: any) {
    this.FIELDS = [
      { key: 'uniqueIdentifier', description: 'Unique ID' },
      { key: 'createdDate', description: 'Date of Barcode Creation' },
      { key: 'createdByUserName', description: 'User Who Created Barcode' },
      { key: 'status', description: 'Status' },
      { key: 'mainDocument', description: 'Main Document' },
      { key: 'oversizedDocument', description: 'Oversized Document' }
    ] as Array<{ key: string; description: string }>;

    this.STATUS_COLOUR_MAPPINGS = {
      [ExceptionalJobStatus.New]: 'light',
      [ExceptionalJobStatus.Error]: 'danger',
      [ExceptionalJobStatus.Completed]: 'success',
      [ExceptionalJobStatus.AwaitingBatch]: 'info',
      [ExceptionalJobStatus.AwaitingOversize]: 'secondary'
    } as { [key in ExceptionalJobStatus]: string };

    this.STATUSES = EnumUtils.getEnumValues(ExceptionalJobStatus);

    this.SORT_FIELDS = [
      { key: 'uniqueIdentifier', label: 'Unique ID' },
      { key: 'createdDate', label: 'Date of Barcode Creation' },
      { key: 'createdByUserName', label: 'User Who Created Barcode' },
      { key: 'status', label: 'Status' }
    ];
  },
  components: { LoadingSpinner, MStoreSimpleTable, MStoreFormDatePicker, MStoreColumnSort }
});
